import { render, staticRenderFns } from "./positivesalon-video-player.vue?vue&type=template&id=707291dc&scoped=true&"
import script from "./positivesalon-video-player.vue?vue&type=script&lang=js&"
export * from "./positivesalon-video-player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707291dc",
  null
  
)

export default component.exports